// Строка для отсутствия результата во vue-select
const SELECT_NOT_FOUND = 'Ничего не найдено';

// Словарь статусов, используется в таблицах и фильтрах
const STATUSES_DICT = {
    // 1: 'Утверждено',
    // 2: 'На утверждении',
    // 3: 'Отклонено',
    1: {
        cls: 'status_success',
        text: 'Утверждено'
    },
    2: {
        cls: 'status_success',
        text: 'Опубликована в Реестре'
    },
    3: {
        cls: 'status_danger',
        text: 'В архиве'
    },
    4: {
        cls: 'status_waiting',
        text: 'Первичная верификация'
    },
    5: {
        cls: 'status_redacted',
        text: 'Отредактировано'
    },
};

export default {
    SELECT_NOT_FOUND,
    STATUSES_DICT,
}
